// extracted by mini-css-extract-plugin
export var heading = "Map-module--heading--+LWwB index-module--c-heading-1--Ya186 default-module--font-bold--5oEvQ";
export var container = "Map-module--container--cJbiH default-module--container--7cp5M";
export var iframeWrapper = "Map-module--iframe-wrapper--FrpbD";
export var list = "Map-module--list--mAEs6";
export var listItem = "Map-module--list-item--a0wWb";
export var caption = "Map-module--caption--I-54k";
export var textBlock = "Map-module--text-block--bwFMy";
export var smallHeading = "Map-module--small-heading--Qe4a3 default-module--font-bold--5oEvQ";
export var small = "Map-module--small--HNJUO";